import { ComponentRef, Directive, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { SkeletonBlockLoaderComponent } from '../skeletons/skeleton-block-loader/skeleton-block-loader.component';
import { SkeletonConfig } from "../models/skeleton-config.model";

@Directive({
  selector: '[appSkeletonLoader]',
  standalone: true
})
export class SkeletonLoaderDirective implements OnChanges, OnDestroy {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  @Input() appSkeletonLoader: boolean = false;
  @Input() appSkeletonLoaderConfig: SkeletonConfig = {
    customHeight: 'auto',
    customWidth: 'auto'
  };

  private hasView = false;
  private skeletonComponentRef: ComponentRef<SkeletonBlockLoaderComponent> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    const hasChanged = changes.appSkeletonLoader && changes.appSkeletonLoader.currentValue !== changes.appSkeletonLoader.previousValue;
    if (hasChanged) {
      this.updateView();
    }

    const hasConfigChanged = changes.appSkeletonLoaderConfig && changes.appSkeletonLoaderConfig.currentValue !== changes.appSkeletonLoaderConfig.previousValue && this.skeletonComponentRef;
    if (hasConfigChanged) {
      this.skeletonComponentRef.instance.config = { ...this.appSkeletonLoaderConfig };
    }
  }

  private updateView(): void {
    if (this.appSkeletonLoader) {
      this.showContent();
    } else {
      this.showSkeleton();
    }
  }

  private showContent(): void {
    if (!this.hasView) {

      const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
      viewRef.rootNodes.forEach(node => {
        node.classList.add('skeleton-animation-fade');
      });
      this.hasView = true;
    }

    if (this.skeletonComponentRef) {
      this.skeletonComponentRef.destroy();
      this.skeletonComponentRef = null;
    }
  }

  private showSkeleton(): void {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }

    if (!this.skeletonComponentRef) {
      this.skeletonComponentRef = this.viewContainer.createComponent(SkeletonBlockLoaderComponent);
      this.skeletonComponentRef.instance.config = { ...this.appSkeletonLoaderConfig };
    }
  }

  ngOnDestroy(): void {
    if (this.skeletonComponentRef) {
      this.skeletonComponentRef.destroy();
    }
  }
}
